import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import icClose from 'assets/svg/ic_close.svg';
import { AppError } from '@profile/src/redux/types';
import { formatErrorMessage } from './utils';
import { claimBox } from '@main/src/redux/remoteActions';
import { useTypedDispatch, useTypedSelector } from '@profile/src/redux/utils';
import Modal from '@profile/src/Components/Modal';
import ThetanButton from '@profile/src/Components/ThetanButton';
import Input from '@profile/src/Components/Input';

const ClaimBoxModal = ({
  onClose,
  onSuccess
}) => {
  const dispatch = useTypedDispatch();
  const [isLoading, setLoading] = React.useState(false);
  const [errorCode, setErrorCode] = React.useState(AppError.NO_ERROR);
  const [keyInput, setKeyInput] = React.useState('');
  const box = useTypedSelector(state => {
    var _state$boxConfigsV2$d;

    return (_state$boxConfigsV2$d = state.boxConfigsV2.data) === null || _state$boxConfigsV2$d === void 0 ? void 0 : _state$boxConfigsV2$d.boxConfigs;
  });

  const onSubmit = async () => {
    setErrorCode(AppError.NO_ERROR);
    setLoading(true);
    const res = await dispatch(claimBox(keyInput));
    setLoading(false);

    if (res.error) {
      setErrorCode(res.error);
      return;
    }

    res.data && box && onSuccess(box[res.data.boxType]);
  };

  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "BOX KEY"), /*#__PURE__*/React.createElement("button", {
    disabled: isLoading,
    onClick: onClose,
    className: styles.close
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icClose
  }))), /*#__PURE__*/React.createElement("span", {
    className: styles.description
  }, "Please enter your Box key to claim the Thetan Box."), /*#__PURE__*/React.createElement(Input, {
    onChange: e => {
      setKeyInput(e.target.value);
    },
    placeholder: "Input your key",
    className: classNames(styles.input, errorCode && styles.error),
    type: "text"
  }), errorCode !== AppError.NO_ERROR && /*#__PURE__*/React.createElement("span", {
    className: styles.errorMessage
  }, formatErrorMessage(errorCode)), /*#__PURE__*/React.createElement(ThetanButton, {
    loading: isLoading,
    disabled: !keyInput,
    className: styles.button,
    title: "Confirm",
    onClick: onSubmit
  })));
};

export default ClaimBoxModal;